<div class="row" *ngIf="industryProfileDetail && !getIndustryDetailLoader && !getStationDeviceDetailsLoader && !getStationDeviceGraphLoader">
  <div class="col-lg-12" *ngIf="industryProfileDetail[0]">
    <div class="card">
      <div class="col-md-12 card-header p-3">
        <div class="row align-items-center">
          <div class="col-md-6">
            <span class="card-title fw-bold fs-5">{{industryProfileDetail[0]?industryProfileDetail[0].name:'NA'}}</span>
            <span class="fs-5 ms-1">({{industryProfileDetail[0]?industryProfileDetail[0].code:'NA'}})</span>
            <div class="text-muted small">{{industryProfileDetail[0]?industryProfileDetail[0].industry_type +' industry':'NA'}}</div>
            <div class="text-muted small">{{industryProfileDetail[0]?industryProfileDetail[0].address:'NA'}}</div>
            <!-- <a href="{{this.industryProfileDetail[0].web_cam_url}}" target="_blank"><img src="assets/images/profile-icon/webcam.png" style="margin-top: -10%; margin-left: -15%;" height="50" width="50"></a> -->
        <div class="heading-elements">
          <a *ngIf="industryProfileDetail[0].web_cam_url" href="{{this.industryProfileDetail[0].web_cam_url}}" target="_blank">
            <img src="assets/images/profile-icon/webcam.png" style="margin-top: -10%; margin-left: -15%;" height="50" width="50">

          </a>
          <img title="Online" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online'" src="assets/images/profile-icon/online.png" style="margin-top: -10%; margin-left: 5%;">
          <img title="Offline" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Offline'" src="assets/images/profile-icon/offline.png" style="margin-top: -10%; margin-left: 5%;">
          <img title="Delay" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Delay'" src="assets/images/profile-icon/delay.png" style="margin-top: -10%; margin-left: 5%;">
        </div>
          </div>

          <div class="col-md-4">
            <div class="row g-3">
              <div class="col-lg-5">
                <label class="form-label small">Start Date</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       placeholder="Industry Report Start Date"
                       class="form-control form-control-sm"
                       #dp="bsDatepicker"
                       bsDatepicker
                       [bsValue]="startReportDate"
                       [maxDate]="maxStartDate"
                       (bsValueChange)="onStartDateChange($event)">
                <input autocomplete="off" pattern="^[^<>]*$" type="time"
                       class="form-control form-control-sm mt-2"
                       [(ngModel)]="startTime"
                       value="{{startTime}}"
                       max="{{endTime}}"
                       (change)="updateEndTime($event)">
              </div>

              <div class="col-lg-5">
                <label class="form-label small">End Date</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       placeholder="Industry Report End Date"
                       class="form-control form-control-sm"
                       #dp="bsDatepicker"
                       bsDatepicker
                       [bsValue]="endReportDate"
                       [minDate]="startReportDate"
                       [maxDate]="maxEndDate"
                       (bsValueChange)="onEndDateChange($event)">
                <input autocomplete="off" pattern="^[^<>]*$" type="time"
                       class="form-control form-control-sm mt-2"
                       [(ngModel)]="endTime"
                       value="{{endTime}}"
                       min="{{startTime}}"
                       (change)="updateStartTime($event)">
              </div>

              <div class="col-lg-2 d-flex align-items-end">
                <button class="btn btn-primary btn-sm" (click)="getDeviceResponse()">
                  <i class="bi bi-search"></i> Search
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="float-end">
<!--              <img title="Online" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online'"-->
<!--                   src="/assets/images/profile-icon/online.png" class="img-fluid" style="height:24px">-->
<!--              <img title="Offline" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Offline'"-->
<!--                   src="/assets/images/profile-icon/offline.png" class="img-fluid" style="height:24px">-->
<!--              <img title="Delay" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Delay'"-->
<!--                   src="/assets/images/profile-icon/delay.png" class="img-fluid" style="height:24px">-->

              <div class="mt-2">
                <button title="Export Excel." class="btn btn-sm btn-outline-secondary me-1" (click)="exportReport('excel')">
                  <i class="icon icon-file-excel"></i>
                </button>
                <a id="exportexcelhref" target="_blank"></a>
                <button title="Export PDF." class="btn btn-sm btn-outline-secondary me-1" (click)="exportReport('pdf')">
                  <i class="icon icon-file-pdf"></i>
                </button>
                <a id="exportpdfhref" target="_blank"></a>
                <button title="Print" class="btn btn-sm btn-outline-secondary" (click)="printPage()">
                  <i class="icon icon-printer"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<br>

<div *ngIf="stationDeviceDetail && stationDeviceLatestResult && !getIndustryDetailLoader && !getStationDeviceDetailsLoader && !getStationDeviceGraphLoader">
  <div class="row" *ngFor="let industry of stationDeviceDetail | keyvalue">
    <div class="col-lg-12" *ngFor="let station of industry.value | keyvalue">
      <div class="card mb-3" style="min-height: 250px;">
        <div class="card-body">
          <h6 class="card-title">{{station.value.station_name}}</h6>
          <hr>

          <div class="row">
            <div class="col-lg-4 mb-3" *ngFor="let devices of station.value.devices | keyvalue">
              <div class="row">
                <div class="col-8">
                  <img src="/assets/images/profile-icon/16.png" style="width:16px" class="img-fluid">
                  <span class="small ms-1">{{ devices.value.label }}</span>
                </div>
                <div class="col-4 small" *ngIf="!stationDeviceLatestResult.length && (industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online'">
                  <span class="float-end">
                    {{(stationDeviceLatestResult && stationDeviceLatestResult[station.key] && stationDeviceLatestResult[station.key][devices.key] && stationDeviceLatestResult[station.key][devices.key]['date_time']) ?
                    (stationDeviceLatestResult[station.key][devices.key]['date_time'] | date: 'dd/MM/yyyy hh:mm a') : '' }}
                  </span>
                </div>
              </div>

              <hr class="my-3">

              <div class="row mb-2">
                <div class="col-6">
                  <a class="float-start text-decoration-none" (click)="viewDiagnostics(station.value.station_id,devices.value,industryProfileDetail[0],station.value.station_name,'today')">View Diagnostics</a>
                </div>
                <div class="col-6">
                  <a class="float-end text-decoration-none" (click)="viewData(station.value.station_id,devices.value,industryProfileDetail[0],station.value.station_name,'today')">View Data</a>
                </div>
              </div>

              <div *ngIf="deviceResponse && deviceResponse['stat_'+station.value.station_id] && deviceResponse['stat_'+station.value.station_id][devices.value.paramkey]"
                   [chart]="deviceResponseChart['stat_'+station.value.station_id][devices.value.paramkey]"
                   class="chart-container" style="height: 200px;"></div>

              <div class="text-center py-5" *ngIf="!(deviceResponse && deviceResponse['stat_'+station.value.station_id] && deviceResponse['stat_'+station.value.station_id][devices.value.paramkey])">
                <span class="badge bg-danger">No Record Found</span>
              </div>

              <div class="row mt-3" *ngIf="!getStationDeviceLatestResultLoader">
                <div class="col-2">
                  <span *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online') && stationDeviceLatestResult && stationDeviceLatestResult[station.key] && stationDeviceLatestResult[station.key][devices.key]">
                    <i *ngIf="stationDeviceLatestResult[station.key][devices.key]['flag'] == 'U'" style="color: #00EB2A;" class="bi bi-hand-thumbs-up fs-4"></i>
                    <i *ngIf="stationDeviceLatestResult[station.key][devices.key]['flag'] != 'U'" style="color: red;" class="bi bi-hand-thumbs-down fs-4"></i>
                  </span>
                  <span *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) != 'Online') || (stationDeviceLatestResult && stationDeviceLatestResult[station.key] && !stationDeviceLatestResult[station.key][devices.key])">
                    <span *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) != 'Online') || (!(stationDeviceLatestResult[station.key][devices.key] && stationDeviceLatestResult[station.key][devices.key]['flag']))"
                          class="badge bg-danger">No Diagnostic</span>
                  </span>
                </div>

                <div class="col-4" *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online') && stationDeviceLatestResult && stationDeviceLatestResult[station.key] && stationDeviceLatestResult[station.key][devices.key]">
                  <button *ngIf="stationDeviceLatestResult[station.key][devices.key]['value'] || stationDeviceLatestResult[station.key][devices.key]['value'] == 0"
                          class="btn btn-primary btn-sm">
                    <div>{{stationDeviceLatestResult[station.key][devices.key]['value'] || stationDeviceLatestResult[station.key][devices.key]['value'] == 0 ? stationDeviceLatestResult[station.key][devices.key]['value'] : 'NA'}}</div>
                    <div>{{stationDeviceLatestResult[station.key][devices.key]['unit'] ? stationDeviceLatestResult[station.key][devices.key]['unit'] : 'NA'}}</div>
                  </button>
                </div>

                <div class="col-6 text-end">
                  <div class="small">
                    <div *ngIf="devices.value.min || devices.value.max">
                      {{devices.value.min ? devices.value.min : ''}} {{devices.value.min ? ' - ' : ''}} {{devices.value.max ? devices.value.max : 'NA'}}
                      {{devices.value.stdunit ? devices.value.stdunit : 'NA'}}
                    </div>
                    <div *ngIf="!devices.value.min && !devices.value.max">N/A</div>
                    <div *ngIf="devices.value.min || devices.value.max">Prescribed Standard</div>
                    <div *ngIf="!(devices.value.min || devices.value.max)">No Standard Define</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="text-center py-5" *ngIf="!industryProfileDetail[0] && !getIndustryDetailLoader && !getStationDeviceDetailsLoader && !getStationDeviceGraphLoader">
  <span class="badge bg-danger">Invalid Industry</span>
</div>

<div class="text-center py-5" *ngIf="getIndustryDetailLoader || getStationDeviceDetailsLoader || getStationDeviceGraphLoader">
  <img src="/assets/images/load.gif" class="img-fluid">
</div>

<div class="modal-backdrop fade show" [ngStyle]="{'display':display}"></div>
<div class="modal fade show" tabindex="-1" [ngStyle]="{'display':display}">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title w-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span class="fs-4">{{this.viewDataDetailsIndustryName}}</span>
              <span class="small ms-2">{{this.viewDataDetailsIndustryCode}}</span>
              <div class="small">{{this.viewDataDetailsStationName}}</div>
              <div class="small text-muted">{{this.viewDataDetailsAddress}}</div>
            </div>
            <div *ngIf="showPopUpReportIcons">
              <button title="Export Excel." class="btn btn-sm btn-outline-secondary me-1" (click)="exportReport('excel')">
                <i class="icon icon-file-excel"></i>
              </button>
              <button title="Export PDF." class="btn btn-sm btn-outline-secondary me-1" (click)="exportReport('pdf')">
                <i class="icon icon-file-pdf"></i>
              </button>
              <button title="Print Graph" class="btn btn-sm btn-outline-secondary" (click)="printChart()">
                <i class="icon icon-printer"></i>
              </button>
            </div>
          </div>
        </h5>
        <button type="button" class="btn-close" (click)="onCloseHandled()"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-3 ms-auto">
            <select (change)="changePeriodForPopupGraph()" [(ngModel)]="popupPeriodSelected" class="form-select form-select-sm float-end">
              <option value="">Select Period</option>
              <option value="today">Today</option>
              <option value="week">Last 7 Days</option>
              <option value="month">Last 30 Days</option>
              <option value="year">Last 1 Year</option>
              <option value="">All</option>
            </select>
          </div>
        </div>

        <div [chart]="popupChart" *ngIf="graphPlot" [hidden]="viewDataDetailsLoader" style="height: 400px; min-width: 310px"></div>

        <div class="text-center py-5" *ngIf="!graphPlot" [hidden]="viewDataDetailsLoader">
          <span class="badge bg-danger">No Record Found</span>
        </div>

        <div class="text-center py-5" [hidden]="!viewDataDetailsLoader">
          <img src="/assets/images/load.gif" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</div>
